export const REQUIRED_SYMBOL = '*';
